import { hasS3Object } from "@/lib/aws-amplify/storage";

import { Converter } from "@/components/features/_shared";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type { ProductDummyRoomFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductDummyRoomFormModel["InputModel"] => {
	const { roomDummyNewItem } = serverModel;

	const inputModel: ProductDummyRoomFormModel["InputModel"] = {
		capacityAdultMaximum: roomDummyNewItem.capacityAdultMaximum,
		capacityKidsMaximum: roomDummyNewItem.capacityKidsMaximum,
		capacityPeopleMaximum: roomDummyNewItem.capacityPeopleMaximum,
		catchCopy: roomDummyNewItem.catchCopy,
		description: roomDummyNewItem.description,
		hotelID: roomDummyNewItem.hotelID,
		inSale: roomDummyNewItem.inSale,
		isKidsUnavailable: roomDummyNewItem.isKidsUnavailable,
		keyVisuals: roomDummyNewItem.keyVisuals ?? [],
		kidsPolicy: roomDummyNewItem.kidsPolicy?.map(Converter.kidsPolicyItemConverter) ?? undefined,
		mainKeyVisual: hasS3Object(roomDummyNewItem.mainKeyVisual)
			? roomDummyNewItem.mainKeyVisual
			: DUMMY_IMAGE.s3Object,
		maxRoomNum: roomDummyNewItem.maxRoomNum,
		name: roomDummyNewItem.name,
		roomID: roomDummyNewItem.roomID,
		availablePlanIDs: roomDummyNewItem.availablePlanIDs,
	} satisfies ProductDummyRoomFormModel["InputModel"];

	return inputModel;
};
